import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon, TicketIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100 % sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès immédiat'
}, {
  icon: CreditCardIcon,
  label: 'Carte de crédit / débit'
}, {
  icon: SmartphoneIcon,
  label: 'Android et iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarif" className="scroll-mt-12 bg-obsidian text-white" data-id="element-195" data-mp="25ry4pi5tkku6">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-196" data-mp="20t4rzrycwxv2">
        <div className="mx-auto max-w-xl text-center" data-id="element-197" data-mp="3h6v4nn3jkugb">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-198" data-mp="3h9he5s9ztk16">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-199" data-mp="3vynlio2kwdf5" /> Offre de lancement limitée
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-200" data-mp="4rkrlovcvt18">
            Obtenez le système complet et les 4 bonus
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-201" data-mp="eq0lfzlrpgef">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-202" data-mp="3rywuqkd1xxam">
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-203" data-mp="2ui7ngb5c22tu">
              Le Système Triathlon Longue Distance™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-204" data-mp="2rftcca3hjhf4">Idéal pour</p>
            <ul className="mt-3 space-y-2.5" data-id="element-205" data-mp="2mgqk5q8lt5ok">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-206" data-mp="316ej4ktbbs94">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-207" data-mp="2w71mj8cn36tc" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-208" data-mp="23ixg2km8uppl">
            <div className="flex items-end gap-3" data-id="element-209" data-mp="23jz1nj0vyulk">
              <span className="font-display text-[84px] font-extrabold leading-[0.8]" style={{
              fontWeight: "700",
              fontFamily: "Inter, sans-serif"
            }} data-id="element-210" data-mp="23la6zn9zcaes">27 €</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-211" data-mp="2dgaeca4e1mgj">54 €</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-212" data-mp="3ttiia95q5ccz">Paiement unique · Accès à vie</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-213" data-mp="3ovz57ckrj5mm">
              Le paiement sera traité dans votre devise locale, selon les modalités de votre prestataire de paiement.
            </p>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-214" data-mp="5b1iluxw98m7">
              Votre système complet comprend
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-215" data-mp="3rg56tdlwmk00">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-216" data-mp="j14y8329q42o">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-217" data-mp="o0hneugm3n8f" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-218" data-mp="a6qo0ewlhjqf">
              Et les 4 bonus offerts
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-219" data-mp="11zhes9vieg8a">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-220" data-mp="16rhhga2yrn8k">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-221" data-mp="3f8jv8b6ish58">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-222" data-mp="3a7w47piak0b0" />
                    <span className="truncate" data-id="element-223" data-mp="358szk6683w3k">{b.title}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-224" data-mp="3180qbcxcpr7a">
                    <span className="text-white/35 line-through" data-id="element-225" data-mp="319k6z4mx649l">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-226" data-mp="1s44phg06atq">OFFERT</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3" data-id="element-227" data-mp="3t19lirt30885">
              <p className="flex items-center gap-2 text-sm font-semibold text-white" data-id="element-228" data-mp="3o63y1ok16lhy">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-229" data-mp="3k6d3d9rdvl85" />
                Garantie de remboursement de 7 jours
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-white/65" data-id="element-230" data-mp="frc6mi3jvx1m">
                Si, pendant les sept premiers jours, vous estimez que le système ne correspond pas à vos besoins,
                vous pouvez demander un remboursement conformément aux conditions de la garantie.
              </p>
            </div>

            <div className="mt-6" data-id="element-231" data-mp="27e9y9fjc47a4">
              <CTAButton className="max-w-none" data-id="element-232" data-mp="2cewjyrovuqke">Obtenez un accès immédiat</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-233" data-mp="2he0qtboc4c7k">
              Vous économisez 27 € par rapport au tarif de référence
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-234" data-mp="2mbj0x5e38xh5">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-235" data-mp="2v5xf14mvu1yo">
                  <Icon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-236" data-mp="304ikbigzrbtz" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-ember" data-id="element-237" data-mp="354d8vfdanpbv">
              <TicketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-238" data-mp="151vk1uaoe7f3" /> Prix de lancement disponible pour une durée limitée
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}